import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Link, withRouter, useHistory } from "react-router-dom";
import PropTypes from "prop-types";
import FeatherIcon from "feather-icons-react";
import
{
  Card,
  CardHeader,
  CardBody,
  Container,
  Form,
  Input,
  Row,
  Col,
  Button,
  Spinner,
} from "reactstrap";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin, { Draggable } from "@fullcalendar/interaction";
import BootstrapTheme from "@fullcalendar/bootstrap";
import SimpleBar from "simplebar-react";
import EvenementFutur from "./evenementFutur.js";
import listPlugin from "@fullcalendar/list";
import { useSelector, useDispatch } from "react-redux";
import BreadCrumb from "../../../../Components/Common/BreadCrumb";
import { withTranslation } from "react-i18next";
import { getEvenements as onGetEvents } from "../../../../store/actions";
import Loader from "../../../../Components/Common/Loader.js";
import axiosInstance from "../../../../axiosConfig.js";
import TableContainer from "../../../../Components/Common/TableContainer.js";
import { toast, ToastContainer } from "react-toastify";

import moment from "moment";
import "moment/locale/fr";
import { lireRoleSession } from "../../../../espace";


moment.locale( "fr" );


const CalendarEvent = ( props ) =>
{
  const history = useHistory();
  const dispatch = useDispatch();
  const [ events, setEvents ] = useState( [] );
  const [ eventSelected, setEventSelected ] = useState( [] );
  const [ filteredEvents, setFilteredEvents ] = useState( [] );
  const [ modal, setModal ] = useState( false );
  const [ deleteModal, setDeleteModal ] = useState( false );
  const [ selectedDay, setSelectedDay ] = useState( 0 );
  const [ selectedNewDay, setSelectedNewDay ] = useState( 0 );
  const [ isEdit, setIsEdit ] = useState( false );
  const [ evenementFutur, setEvenementFutur ] = useState( [] );
  const [ categories, setCategories ] = useState( [] );
  const [ searchQuery, setSearchQuery ] = useState( "" );
  const [ showMode, setShowMode ] = useState( "Table" );
  const [ loading, setLoading ] = useState( true );
  const [ loadingPublier, setLoadingPublier ] = useState( false );

  const [ evenements, setEvenements ] = useState( [] );

  const [ roleSession, setRoleSession ] = useState( lireRoleSession )
  const [ idConnected, setIdConnected ] = useState( null )

  function getSessionData ()
  {
    if ( localStorage.getItem( "authUser" ) )
    {
      const obj = JSON.parse( localStorage.getItem( "authUser" ) );
      console.log( 'obj localStorage: ', obj )
      setRoleSession( obj.role )
      if ( obj.data )
      {
        setIdConnected( obj.data.id )
      }
    }
  }


  const fetchEvent = async () =>
  {
    try
    {
      console.log( "roleSession: ", roleSession )
      let evenment_list;
      if ( roleSession === "ORGANISATEUR" )
      {
        // La ligne qui appelait /eventgetallfororga/ avait été mise en
        // commentaire au profit de /eventgetall/, réservé à l'administration :
        // l'organisateur recevait un 403, le catch avalait l'erreur, et la
        // liste restait vide — y compris juste après avoir créé un événement.
        evenment_list = await axiosInstance.get( `/eventgetallfororga` );

        setEvenements(
          evenment_list.data ? evenment_list.data.data : []
        );
      } else
      {
        evenment_list = await axiosInstance.get( `/eventgetall` );
        // console.log( "evenment admin: ", evenment_list );

        setEvenements(
          evenment_list.data ? evenment_list.data.data : []
        );
      }

    } catch ( err )
    {
      console.error( err );
    }
    setLoading( false );
  };


  useEffect( () =>
  {
    getSessionData()
  }, [] )

  useEffect( () =>
  {
    fetchEvent()
  }, [ roleSession ] );

  const handleChangeShowMode = ( mode ) =>
  {
    setShowMode( mode )
  }

  const transformEvents = ( events ) =>
  {
    return events.map( ( event ) => ( {
      id: event.id,
      title: event.nom,
      start: event.date
        ? new Date(
          `${ event.date.split( "T" )[ 0 ] }T${ event.heure ? event.heure : "00:00" }`
        )
        : null,
      end: event.date_fin
        ? new Date(
          `${ event.date_fin.split( "T" )[ 0 ] }T${ event.heure_fin ? event.heure_fin : "00:00"
          }`
        )
        : null,
      className: event.categorie,
      location: event.lieu,
      description: event.description,
    } ) );
  };

  useEffect( () =>
  {
    if ( evenements )
    {
      setCategories( getUniqueCategorie( evenements ) );

      const sortedEvents = evenements.filter(
        ( event ) => event.publier !== "RETIRER" && event.status === "A VENIR"
      );

      setEvents( sortedEvents );
      setFilteredEvents( transformEvents( sortedEvents ) );

      const sortedEventDate = sortedEvents.filter( ( event ) =>
      {
        const eventDate = new Date( event.date_debut ); // Assurez-vous que `date_debut` est le bon champ pour la date de début
        const currentDate = new Date();

        return event.publier !== "RETIRER" && event.status === "A VENIR" && eventDate > currentDate;
      } );
      setEvenementFutur( transformEvents( sortedEventDate ) );
      console.log( "sortedEvents: ", transformEvents( sortedEvents ) );
    }
  }, [ evenements ] );

  function getUniqueCategorie ( events )
  {
    let category = events.map( ( event ) => event.categorie );
    category = [ ...new Set( category ) ];
    return category;
  }

  const handleDateClick = ( arg ) =>
  {
    const date = arg[ "date" ];
    const day = date.getDate();
    const month = date.getMonth();
    const year = date.getFullYear();

    const currectDate = new Date();
    const currentHour = currectDate.getHours();
    const currentMin = currectDate.getMinutes();
    const currentSec = currectDate.getSeconds();
    const modifiedDate = new Date(
      year,
      month,
      day,
      currentHour,
      currentMin,
      currentSec
    );

    const modifiedData = { ...arg, date: modifiedDate };

    setSelectedNewDay( date );
    setSelectedDay( modifiedData );
  };

  const handleEventClick = useCallback( ( arg ) =>
  {
    // Extraction des informations de l'événement
    const event = arg.event;
    // console.log("Selectionner un évenement: ", event);
    history.push( `/evenements/${ event.id }` );
    // const eventInfo = {
    //   id: event.id,
    //   title: event.title,
    //   start: event.start,
    //   end: event.end,
    //   allDay: event.allDay,
    //   extendedProps: event.extendedProps,
    // };

    setEventSelected( event );

    setIsEdit( true );
  }, [ history ] );


  const date_r = ( date ) =>
  {
    const d = new Date( date );
    const day = d.getDate().toString().padStart( 2, "0" );
    const month = ( d.getMonth() + 1 ).toString().padStart( 2, "0" );
    const year = d.getFullYear();

    return `${ year }-${ month }-${ day }`;
  };

  const handleSearch = ( event ) =>
  {
    setSearchQuery( event.target.value );
  };

  useEffect( () =>
  {
    const filtered_event = events.filter( ( event ) =>
    {
      const lowerQuery = searchQuery.toLowerCase();
      return (
        event.nom.toLowerCase().includes( lowerQuery ) ||
        event.description.toLowerCase().includes( lowerQuery ) ||
        date_r( event.date ).includes( lowerQuery )
      );
    } );
    // console.log("filtered_event: ", transformEvents(filtered_event));
    // setFilteredEvents(filtered_event);
    setFilteredEvents( transformEvents( filtered_event ) );
  }, [ searchQuery, events ] );



  const eventSubmitUpdate = async ( eventId, statut ) =>
  {
    console.log( "eventId: ", eventId )

    setLoadingPublier( true )
    try
    {
      // const logo = logo.current;
      // const banniere = banniere.current;
      // Le contrôleur lit `event_id` et `publier` dans le corps ; il recevait
      // `status` et un identifiant en query, et répondait 400 à chaque fois.
      const status_update = {
        event_id: eventId,
        publier: statut,
      }
      console.log( "status_update: ", status_update )

      try
      {
        setLoadingPublier( true );
        const res = await axiosInstance.post( "/eventupdatestatuspublication/", status_update );
        if ( res.status === 200 )
        {
          fetchEvent();
          console.log( "res submit: ", res );
          console.log( res.data );

          toast.success( ( `Publication de l'événement ${ statut == "RETIRER" ? "retiré" : "publié" } avec succès` ), {
            autoClose: 3000,
          } );
        } else
        {

          toast.error( ( `Erreur lors  ${ statut == "RETIRER" ? "du retrait" : "de la publication" } de l'evenement` ), {
            autoClose: 3000,
          } );
        }
      } catch ( error )
      {
        console.error( "Erreur lors de la mise à jour :", error );
      } finally
      {
        setLoadingPublier( false );
      }


    } catch ( error )
    {
      toast.error( ( "Erreur lors de la modification de l'evenement" ), {
        autoClose: 3000,
      } );
      console.error( "Erreur lors de la modification de l'événement", error )
    }
    setLoadingPublier( false )
  }

  const handleUpdate = useCallback( ( id, status ) =>
  {
    // setLoadingPublier( true )

    console.log( `Clique sur ${ id }` );
    eventSubmitUpdate( id, status );
    // setLoadingPublier( false )
  }, [] );


  // Column
  const columns = useMemo(
    () => [
      {
        Header: props.t( "Nom de l'événement" ),
        accessor: "nom",
        filterable: false,
      },
      {
        Header: props.t( "Categorie" ),
        accessor: "categorie",
        filterable: true,
      },
      {
        Header: props.t( "Numero" ),
        accessor: "numero",
        filterable: false,
      },
      {
        Header: props.t( "Publier ?" ),
        accessor: "publier",
        filterable: true,

        Cell: ( item ) => (
          <div className="">
            <span className="mr-2">
              { item.row.original.publier }
              { " " }
            </span>

            { item.row.original.publier === "RETIRER" && roleSession !== "ORGANISATEUR" &&
              <Button
                disabled={ loadingPublier }
                className="btn btn-success btn-sm ml-3"
                style={ { marginLeft: 5 } }
                onClick={ () => handleUpdate( `${ item.row.original.id }`, "PUBLIER" )
                }
              >
                {
                  loadingPublier ?
                    <Spinner size={ "sm" } /> :
                    <span>
                      Publier
                    </span>
                }
              </Button>
            }
            { item.row.original.publier === "PUBLIER" &&
              <Button
                disabled={ loadingPublier }
                className="btn btn-danger btn-sm ml-3"
                style={ { marginLeft: 5 } }
                onClick={ () => handleUpdate( `${ item.row.original.id }`, "RETIRER" )
                }
              >
                {
                  loadingPublier ?
                    <Spinner size={ "sm" } /> :
                    <span>
                      Retirer
                    </span>
                }
              </Button>
            }
          </div>
        )
      },
      {
        Header: props.t( "Début" ),
        accessor: "date",
        filterable: false,
        Cell: ( item ) => (
          <span>
            { moment( item.row.original.date ).format( "YYYY-MM-DD" ) } à { item.row.original.heure }
          </span>
        ),
      }, {
        Header: props.t( "Fin" ),
        accessor: "date_fin",
        filterable: false,
        Cell: ( item ) => (
          <span>
            { moment( item.row.original.date_fin ).format( "YYYY-MM-DD" ) } à { item.row.original.heure_fin }
          </span>
        ),
      },
      {
        Header: props.t( "Fin vente ticket" ),
        accessor: "date_fin_vente",
        filterable: false,
        Cell: ( item ) => (
          <span>
            { moment( item.row.original.date_fin_fin ).format( "YYYY-MM-DD" ) }
          </span>
        ),
      },
      {
        Header: props.t( "Lieu" ),
        accessor: "lieu",
        filterable: false,
      },
      {
        Header: props.t( "Status" ),
        accessor: "status",
        filterable: true,
      },
      {
        Header: props.t( "Action" ),
        accessor: "id",
        filterable: false,
        Cell: ( item ) => (
          <ul className="list-inline hstack gap-2 mb-0">
            <Link
              to={ `/evenements/${ item.row.original.id }` }
              className="btn btn-primary"
            >
              <i className="ri-eye-fill align-bottom"></i>
            </Link>
            {
              roleSession === "ORGANISATEUR" &&
              <Link
                to={ `/evenements/add/${ item.row.original.id }` }
                className="btn btn-outline-warning"
              >
                <i className="ri-pencil-fill align-bottom"></i>
              </Link>
            }

          </ul>
          // evenements/add/7
        ),
      },
    ],
    [ loadingPublier, roleSession ]
  );

  const [ eventTable, setEventTable ] = useState( [] )
  useEffect( () =>
  {
    const event =
      roleSession !== "ORGANISATEUR" ?
        evenements :
        evenements.filter( item => item.organisation_id === idConnected )
    setEventTable( event )
    //   console.log( 'event: ', event )

  }, [ roleSession, evenements, idConnected ] );

  document.title = `${ props.t( "Events" ) } | Takci`;

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title={ props.t( "Events" ) } pageTitle="Takci" />
          <Row>
            {
              roleSession === "ORGANISATEUR" &&
              <Col lg={ 12 }>
                <Card>
                  <CardHeader>
                    <div className="d-flex justify-content-end">
                      <div className="flex-shrink-0">
                        <button
                          className="btn add-btn"
                          style={ { background: "#002437", color: "white" } }
                          onClick={ () =>
                          {
                            // setModal(true);
                            history.push( "/evenements/add" );
                          } }
                        >
                          <i className="ri-user-add-line me-1 align-bottom"></i>
                          { ( "Ajouter événement" ) }
                        </button>
                      </div>
                    </div>
                  </CardHeader>
                </Card>
              </Col>
            }

            { loading ? (
              <div className="text-center my-5">
                <Loader style={ { color: "#014c94" } } />
                <h2>Chargement...</h2>
              </div>
            ) : (
              evenements.length > 0 ?
                <Col xs={ 12 }>
                  <div className="w-100 d-flex gap-2 justify-content-end mb-2">
                    {/* <button
                      disabled={ showMode === "Calendar" }
                      type="button"
                      className={ `btn ${ showMode === "Calendar" ? "btn-secondary" : "btn-soft-secondary" }` }
                      onClick={ () =>
                      {
                        handleChangeShowMode( "Calendar" )
                        // onChangeChartPeriod( "mois" );
                      } }
                    >
                      Calendrier
                    </button> */}
                    <button
                      disabled={ showMode === "Table" }
                      type="button"
                      className={ `btn ${ showMode === "Table" ? "btn-secondary" : "btn-soft-secondary" }` }
                      onClick={ () =>
                      {
                        handleChangeShowMode( "Table" )
                        // onChangeChartPeriod( "mois" );
                      } }
                    >
                      Tableau
                    </button>
                    {/* <button disabled={ revenuePeriod =="semaine"} type="button" className="btn btn-soft-secondary btn-sm" onClick={ () => { onChangeChartPeriod( "semaine" ); } }>
                                Semaine
                            </button> */}
                  </div>

                  {
                    //   showMode === "Calendar" ?
                    //     <Row>
                    //       <Col xl={ 3 }>
                    //         {/* <Card className="card-h-100">
                    //   <CardHeader>Catégorie(s)</CardHeader>
                    //   <CardBody>
                    //     <div id="external-events">
                    //       {categories &&
                    //         categories.map((category, key) => (
                    //           <div
                    //             className={`bg-soft-primary external-event fc-event text-primary`}
                    //             key={"cat-" + key}
                    //           >
                    //             <i className="mdi mdi-checkbox-blank-circle font-size-11 me-2" />
                    //             {category}
                    //           </div>
                    //         ))}
                    //     </div>
                    //   </CardBody>
                    // </Card> */}
                    //         { searchQuery ? (
                    //           <div>
                    //             <h5 className="mb-1">{ props.t( "Events searched" ) }</h5>

                    //             <SimpleBar
                    //               className="pe-2 me-n1 mb-3"
                    //               style={ { height: "400px" } }
                    //             >
                    //               <div id="upcoming-event-list">
                    //                 { filteredEvents &&
                    //                   filteredEvents.map( ( event, key ) => (
                    //                     <React.Fragment key={ key }>
                    //                       <EvenementFutur event={ event } />
                    //                     </React.Fragment>
                    //                   ) ) }
                    //               </div>
                    //             </SimpleBar>
                    //           </div>
                    //         ) : (
                    //           <div>
                    //             <h5 className="mb-1">{ props.t( "Upcoming Events" ) }</h5>
                    //             <p className="text-muted">
                    //               Ne manquez pas les événements programmés
                    //             </p>
                    //             <SimpleBar
                    //               className="pe-2 me-n1 mb-3"
                    //               style={ { height: "400px" } }
                    //             >
                    //               <div id="upcoming-event-list">
                    //                 { evenementFutur &&
                    //                   evenementFutur.map( ( event, key ) => (
                    //                     <React.Fragment key={ key }>
                    //                       <EvenementFutur event={ event } />
                    //                     </React.Fragment>
                    //                   ) ) }
                    //               </div>
                    //             </SimpleBar>
                    //           </div>
                    //         ) }
                    //       </Col>

                    //       <Col xl={ 9 }>
                    //         <Card className="card-h-100">
                    //           <CardBody>
                    //             <Form
                    //               className="d-flex mb-4"
                    //               onSubmit={ ( e ) =>
                    //               {
                    //                 e.preventDefault();
                    //                 handleSearch();
                    //               } }
                    //             >
                    //               <Input
                    //                 type="text"
                    //                 placeholder="Rechercher par titre, description ou date..."
                    //                 value={ searchQuery }
                    //                 onChange={ handleSearch }
                    //               />
                    //             </Form>

                    //             <FullCalendar
                    //               plugins={ [
                    //                 BootstrapTheme,
                    //                 dayGridPlugin,
                    //                 interactionPlugin,
                    //                 listPlugin,
                    //               ] }
                    //               initialView="dayGridMonth"
                    //               slotDuration={ "00:15:00" }
                    //               handleWindowResize={ true }
                    //               themeSystem="bootstrap"
                    //               headerToolbar={ {
                    //                 left: "prev,next today",
                    //                 center: "title",
                    //                 right:
                    //                   "dayGridMonth,dayGridWeek,dayGridDay,listWeek",
                    //               } }
                    //               events={ filteredEvents }
                    //               editable={ true }
                    //               droppable={ false }
                    //               selectable={ true }
                    //               dateClick={ handleDateClick }
                    //               eventClick={ handleEventClick }
                    //             />
                    //           </CardBody>
                    //         </Card>
                    //       </Col>
                    //     </Row> :
                    <Row>
                      <TableContainer
                        columns={ columns }
                        data={ eventTable }
                        isGlobalFilter={ true }
                        isAddUserList={ false }
                        customPageSize={ 8 }
                        className="custom-header-css"
                        divClass="table-responsive table-card mb-3"
                        tableClass="align-middle table-nowrap"
                        theadClass="table-light"
                      // handleChauffeurClick={handleChauffeurClicks}
                      />
                    </Row>
                  }
                </Col> :
                <Col xs={ 12 }>
                  <div className="text-center my-5 text-lg">
                    Aucun évenement
                  </div>
                </Col>
            ) }
          </Row>
          <ToastContainer closeButton={ false } />
        </Container>
      </div>
    </React.Fragment>
  );
};

CalendarEvent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,

  events: PropTypes.any,
  categories: PropTypes.array,
  className: PropTypes.string,

  onGetEvents: PropTypes.func,
  onAddNewEvent: PropTypes.func,
};

export default withRouter( withTranslation()( CalendarEvent ) );
